import React from 'react';
import {object} from 'prop-types';

import classes from './PanelInsert.module.css';

const SystemPanelInsert = ({node}) => {
    return (
        <dl className={classes.agentInfo}>
            <dt>Name</dt>
            <dd>{node.name}</dd>

            <dt>System Type</dt>
            <dd>{node.systemType.name}</dd>
        </dl>
    );
};

SystemPanelInsert.defaultProps = {
    node: {}
};

SystemPanelInsert.propTypes = {
    node: object.isRequired
};

export default SystemPanelInsert;
